import * as React from "react";
import * as ReactDOM from "react-dom";
import { TabControlTemplate } from "./";

interface IProperties
{
    /**
     * Das Template des TabControls. Hiermit kann das Design des TabControls verändert werden.
     */
    template?: TabControlTemplate,

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Inline-Style für die TabPages.
     */
    styleTabPages?: React.CSSProperties,

    /**
     * Inline-Style für die TabPanels.
     */
    styleTabPanels?: React.CSSProperties,

    /**
     * CSS-Klassen die dem TabControl angehängt werden.
     */
    className?: string,

    /**
     * CSS-Klassen die den TabPages angehängt werden.
     */
    classNameTabPages?: string,

    /**
     * CSS-Klassen die den TabPanels angehängt werden.
     */
    classNameTabPanels?: string,

    /**
     * Alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Der selektierte Index der beim Erststart verwendet wird.
     */
    defaultIndex?: number,

    /**
     * Der momentane selektierte Index.
     */
    selectedIndex?: number,

    /**
     * Wird ausgelöst, sobald sich das selektierte Tab ändert.
     */
    onTabChanged?: (index: number) => void
}

export class TabControl extends React.Component<IProperties>
{
    /**
     * Erstellt eine neue Instanz der Klasse @see TabControl.
     * @param props Alle gesetzten Eigenschaften.
     */
    constructor(props: IProperties)
    {
        super(props);
    }

    /**
     * Wird ausgeführt, sobald auf ein Tab geklickt wird.
     * @param e Das auslösende Ereignis.
     */
    private onTabChanged = (index: number) =>
    {
        this.props.onTabChanged && this.props.onTabChanged(index);
    }

    /**
     * Rendert die Tabs des TabControls.
     */
    private renderTabs(): JSX.Element[]
    {
        const { template, children, defaultIndex, selectedIndex } = this.props;

        return React.Children.map(children, (child: any, index) =>
        {
            let selected = selectedIndex != null ? selectedIndex : defaultIndex;
            selected = selected || 0;

            if (React.isValidElement(child))
            {
                return React.cloneElement(child as any, {
                    template: template,
                    index: index,
                    isSelected: index === selected,
                    onClick: this.onTabChanged
                });
            }
        });
    }

    /**
     * Rendert die Panels der Tabs.
     */
    private renderPanels(): JSX.Element[]
    {
        const { children, defaultIndex, selectedIndex } = this.props;

        return React.Children.map(children, (child: JSX.Element, index) =>
        {
            let selected = selectedIndex != null ? selectedIndex : defaultIndex;
            selected = selected || 0;

            if (index === selected)
            {
                return child.props.children;
            }
        });
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const {
            template,
            style,
            styleTabPages,
            styleTabPanels,
            className,
            classNameTabPages,
            classNameTabPanels
        } = this.props;

        var templateTabControlClassName: string;
        var templateTabClassName: string;
        var templateTabPanelClassName: string;
        switch (template)
        {
            case TabControlTemplate.style2:
                {
                    templateTabControlClassName = "tabcontrol";
                    templateTabClassName = "tabcontrol_tabs";
                    templateTabPanelClassName = "tabcontrol_panels";
                }
                break;
            default:
                {
                    templateTabControlClassName = "tabcontrol";
                    templateTabClassName = "tabcontrol_tabs";
                    templateTabPanelClassName = "tabcontrol_panels";
                }
                break;
        }

        return (
            <div
                style={style}
                className={templateTabControlClassName + " " + (className ? className : "")}>
                <div
                    style={styleTabPages}
                    className={templateTabClassName + " " + (classNameTabPages ? classNameTabPages : "")}>
                    {this.renderTabs()}
                </div>
                <div
                    style={styleTabPanels}
                    className={templateTabPanelClassName + " " + (classNameTabPanels ? classNameTabPanels : "")}>
                    {this.renderPanels()}
                </div>
            </div>
        );
    }
}